// Module
var code = "<div class=\"dms-filter-wrapper dms-outer-element\">\n    <div class=\"dms-grid-wrapper dms-filter #=data.GridName#\"></div>\n</div>\n";
// Exports
export default code;